// src/pages/PoliticaEntrega.js
import React from 'react';
import "./LegalPages.css";

function PoliticaEntrega() {
  return (
    <div className="legal-page">
      <h1>📌 POLÍTICA DE ENTREGA - SANTO DOMINGO ESPECTÁCULOS</h1>
      <p>En Santo Domingo Espectáculos, nos comprometemos a garantizar la entrega rápida y segura de sus boletos una vez verificado su pago.</p>
      
      <h2>1. Proceso de Entrega</h2>
      <p>La verificación del pago y el envío de boletos es un proceso automatizado.</p>
      <p>Una vez que el pago sea aprobado, los boletos serán enviados de forma automática.</p>
      <p><strong>Formato de entrega:</strong> Los boletos se enviarán en formato HTML y PDF al correo electrónico proporcionado al momento de la compra.</p>
      
      <h2>2. Código de Acceso al Evento</h2>
      <p>Cada boleto incluirá un <strong>Código QR único e irrepetible</strong> con información cifrada.</p>
      <p>Este código debe ser presentado al momento del ingreso al evento para su verificación mediante un escáner especializado.</p>
      
      <h2>3. ¿No recibió sus boletos?</h2>
      <p>Si no ha recibido sus boletos en un plazo máximo de 1 hora después de haber recibido su confirmación de pago, por favor:</p>
      <ul>
        <li>Revise su bandeja de correo no deseado (spam).</li>
        <li>Contáctenos por email o teléfono para verificar el estado de su pedido y gestionar un reenvío manual si es necesario.</li>
      </ul>
    </div>
  );
}
export default PoliticaEntrega;
